<template>

  <el-container>
    <el-header style="width: 1400px;max-width: 100%;margin: 0 auto">
      <img style="width: 100px;float: left;vertical-align: middle;margin-top: 18px" :src="$baseUrl+'img/paraverse-dev-logo.png'"/>
      <div class="fr" style="margin-top: 20px;margin-right:5px;cursor: pointer">
        <el-link href="https://www.pingxingyun.com/community/classify" target="_blank">
          云社区
        </el-link>
      </div>

    </el-header>
    <el-main class="pxy-main" style="background:url('https://home-oss.pingxingyun.com/homePage/developer/bg.jpg')">
      <el-card style="max-width: 550px;margin: 0 auto">
      <p class="login_title  extra-large">创建平行云账号</p>
      <el-divider class="divider"></el-divider>
      <el-form :rules="rules" :model="form" ref="form" class="reg-form" label-position="right"
               label-width="100px" v-loading="loading" auto-complete="off"
               data-cl-attached="false" data-cl-id="762ba725ddd048a68bd61ac734da5bda">
        <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>

        <el-form-item prop="accountId" label="账户名：">
          <el-input placeholder="账户名" v-model="form.accountId" class="login-id">
            <el-select v-model="form.role" slot="append" placeholder="账号类型" style="width: 107px">
              <el-option :key=1 label="个人用户" :value=1>
              </el-option>
              <el-option :key=2 label="企业用户" :value=2>
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item prop="verifyCode" label="图形验证码：">
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" style="padding: 0 !important;">
            <el-input type="text" v-model="form.verifyCode" auto-complete="off" placeholder="图形验证码"></el-input>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <a class="" href="javascript:void(0);"><img v-on:click="change()" ref="captcha" class="captcha authCode" /></a>
          </el-col>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号：">
          <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
            <el-input v-model="form.mobile" auto-complete="off" placeholder="手机号" name="mobile" class="input-with-select">
              <el-select v-model="form.countryMob" slot="prepend" placeholder="请选择" class="country-mobile-select">
                <el-option v-for="item in countryList" :key="item.value" :value="item.value">{{item.label}}&nbsp;&nbsp;{{item.value}}</el-option>
              </el-select>
            </el-input>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" class="sendBtn send-btn">
                  <smsCode :mobile="form.mobile" type="1" :countryMob="form.countryMob" :captcha="form.verifyCode" :captchaId="captchaId" @changeCaptcha="change"></smsCode>
          </el-col>
        </el-form-item>
        <el-form-item prop="email" label="邮箱：">
          <el-input class="col-md-12" type="text" v-model="form.email"
                    placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item prop="smsCode" label="验证码：">
          <el-input class="col-md-12" type="text" v-model="form.smsCode" auto-complete="off"
                    placeholder="验证码"></el-input>
          <el-input type="text" style="position: fixed;bottom: -9999px"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="密码：">
          <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
          <el-input class="col-md-12" type="password" v-model="form.password" auto-complete="off"
                    placeholder="设置密码(长度8-16位，数字和字母组合)"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密码：">
          <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>
          <el-input class="col-md-12" type="password" v-model="form.confirmPassword" auto-complete="off"
                    placeholder="确认密码(长度8-16位，数字和字母组合)"></el-input>
        </el-form-item>

        <el-form-item label="地址：">
          <el-select  v-model="form.provinceIndex" filterable placeholder="省份" @change="getCityList($event)" style="width: 50%">
            <el-option
              v-for="(item,index) in provinceList"
              :key="index"
              :label="item.province"
              :value="index">
            </el-option>
          </el-select>
          <el-select v-model="form.cityIndex" filterable placeholder="城市" style="width: 50%">
            <el-option
              v-for="(item,index) in cityList"
              :key="index"
              :label="item.city"
              :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="company" label="公司名称：">
          <el-input class="col-md-12" type="text" v-model="form.company" auto-complete="off"
                    placeholder="公司名称" name="company"></el-input>
        </el-form-item>
        <div style="display: flex;">
          <label class="reg-form-label">业务领域：</label>
          <div style="display: flex;width:calc(100% - 100px);">
            <el-form-item  prop="busiScope" class="reg-form-item" style="width: 100%;">
              <el-select class="col-md-12" v-model="form.busiScope" filterable placeholder="业务领域" style="width: 100%">
                <el-option
                  v-for="item in busiScopeList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="jobTitle" class="reg-form-item" style="width: 100%;">
              <el-select class="col-md-12" v-model="form.jobTitle" filterable placeholder="岗位" style="width: 100%">
                <el-option
                  v-for="item in jobTitleList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div style="display: flex;">
          <el-form-item v-if="cl.source" label="渠道：">
            <el-tag>{{cl.source}}</el-tag>
          </el-form-item>
          <el-form-item v-if="cl.contentName" label="关键词：">
            <el-tag>{{cl.contentName}}</el-tag>
          </el-form-item>
        </div>

        <el-form-item class="reg-form-item">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-button type="primary" style="width: 100%" @click.native.prevent="regist">立即注册</el-button>
          </el-col>
        </el-form-item>

        <el-form-item class="reg-form-item">
          <el-checkbox style="float: left" v-model="checked"></el-checkbox>
          <a href="https://www.pingxingyun.com/provisions.html" target="_blank" >&nbsp;阅读并同意《用户协议和隐私政策》</a>
          <div style="float: right">已有账号？
            <router-link :to="{ path: '/login'}">去登录</router-link>
          </div>
        </el-form-item>
      </el-form>
      </el-card>
    </el-main>
  </el-container>
</template>
<script>
  import comm from '@/utils/comm'
  import {Message} from "element-ui";
  import smsCode from '@/components/smsCodeComponent'
  import Cookies from "js-cookie";
  import $ from 'jquery'
  const countryList = [
    {label: '中国/China', value: '+86'},
    {label: '中国香港/Hong Kong', value: '+852'},
    {label: '中国台湾/Taiwan', value: '+886'},
    {label: '中国澳门/Macao', value: '+853'},
    {label: '澳大利亚/Austria', value: '+61'},
    {label: '加拿大/Canada', value: '+1'},
    {label: '瑞士/Switzerland', value: '+41'},
    {label: '德国/Germany', value: '+49'},
    {label: '丹麦/Denmark', value: '+45'},
    {label: '法国/France', value: '+33'},
    {label: '英国/United Kingdom', value: '+44'},
    {label: '爱尔兰/Ireland', value: '+353'},
    {label: '意大利/Italy', value: '+39'},
    {label: '日本/Japan', value: '+81'},
    {label: '韩国/South Korea', value: '+82'},
    {label: '开曼群岛/Cayman Islands', value: '+1345'},
    {label: '马尔代夫/Maldives', value: '+960'},
    {label: '墨西哥/Mexico', value: '+52'},
    {label: '马来西亚/Malaysia', value: '+60'},
    {label: '荷兰/Netherlands', value: '+31'},
    {label: '挪威/Norway', value: '+47'},
    {label: '新西兰/New Zealand', value: '+64'},
    {label: '新加坡/Singapore', value: '+65'},
  ]
  export default {
    components: {smsCode},
    created: function () {
      if (this.$store.state.user != null && this.$store.state.user.userName != null && this.$store.state.user.userName != '') {
        // this.getUserSession();
      }
      comm.loadEnterFun(this.submitClick);
    },
    mounted: function () {
      // 存储注册来源字段
      if(this.$route.query.source){
        window.localStorage.setItem('source', this.$route.query.source);
      } else {
        if(window.localStorage.getItem('source')) window.localStorage.removeItem('source');
      }
      this.change();
      this.getRegionInfo();
      this.getProvinceList();
      this.getCookie();

      // 表单数据采集-追踪脚本
      // const oScript = document.createElement('script');
      // oScript.type = 'text/javascript';
      // oScript.src = '//cbe.huiju.cool/cbe/collect?tid=5532885912031582559&at=0&h=web';
      // document.body.appendChild(oScript);
      // marketup埋点-----start
      // const marketupScript = document.createElement('script');
      // marketupScript.type = 'text/javascript';
      // marketupScript.src = 'https://www.marketup.cn/resources/js/analytics.js';
      // document.body.appendChild(marketupScript);
      // const marketupScript_1 = document.createElement('script');
      // marketupScript_1.type = 'text/javascript';
      // marketupScript_1.src = 'https://www.marketup.cn/resources/js/floatingbar/floatingbar.js';
      // document.body.appendChild(marketupScript_1);
      // const marketupScriptCode = document.createElement('script');
      // marketupScriptCode.type = 'text/javascript';
      // marketupScriptCode.defer = 'defer';
      // marketupScriptCode.innerHTML = `
      //   window.onload=function(){
      //     var analytics  = new _MARKETUP_ANALYTICS.Analytics({base:'https://paraverse.marketup.cn',siteId:4364007118682113})
      //     analytics.page()
      //   }`;
      // document.body.appendChild(marketupScriptCode);
      // marketup埋点-----end
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }else if (this.form.confirmPassword != '' && value != this.form.confirmPassword) {
          console.log(this.form.confirmPassword)
          callback(new Error('两次输入密码不一致!'));
        }
        callback();
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
      return {
        baseUrl: this.$apiUrl,
        checked: true,
        rules: {
          accountId: [{required: true, message: '请输入账户名', trigger: 'blur'},
            {max: 16, message: "长度在16个字符以内", trigger: 'blur'}],
          password: [  {required: true, validator: validatePass, trigger: 'blur' },
            {max: 128, message: "长度在128个字符以内", trigger: 'blur'}],
          smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          email: [{required: true, message: '请输入邮箱', trigger: 'blur'}],
          mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}, {max: 16, message: "长度在16个字符以内", trigger: 'blur'}],
          confirmPassword: [  {required: true, validator: validatePass2, trigger: 'blur' }],
          company: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
          busiScope: [{required: true, message: '请选择业务领域', trigger: 'blur'}],
          jobTitle: [{required: true, message: '请选择岗位', trigger: 'blur'}],
        },
        captchaId: '',
        form: {
          accountId: '',
          mobile: '',
          email: '',
          password: '',
          verifyCode: '', //图片验证码
          smsCode: '', //手机验证码
          role: 1,
          confirmPassword:'',
          provinceIndex:'',
          cityIndex:'',
          company:'',
          busiScope:'',
          jobTitle:'',
          // source: '', // 渠道
          // term: '', // 关键词
          countryMob: '+86'
        },
        provinceList:[],
        cityList:[],
        loading: false,
        busiScopeList:[
          "数字孪生",
          "教育教学",
          "展览展示",
          "游戏娱乐",
          "虚拟直播",
          "虚拟演出",
          "3D品牌营销",
          "数字藏品",
          "超写实数字人",
          "其他"
        ],
        jobTitleList:[
          "研发工程师",
          "研发负责人",
          "公司负责人",
          "部门负责人",
          "商务销售人员",
          "教师",
          "学生",
          "其他"
        ],
        cl: {},//埋点-cookie存储的相关信息，提交表单时使用
        countryList: countryList
      }
    },
    methods: {
      change: function () {
          this.getRequest('/uacUser/captcha', {'d': new Date().getTime()}).then(resp => {
            this.$refs.captcha.src = resp.data.result;
            this.captchaId = resp.headers.captchaid;
          })
      },
      regist: function () {
        var _this = this;
        this.form.mobile = this.form.countryMob==='+86' ? this.form.mobile : this.form.countryMob + this.form.mobile
        if(this.cl.source) this.form.utmSource = this.cl.source;
        if(this.cl.contentName) {
          this.form.utmTerm = this.cl.contentName;
          this.form.contentName = this.cl.contentName;
        }
        var regPos = /^[0-9]+.?[0-9]*$/;
        if(regPos.test(this.form.provinceIndex)){
          this.form.province = _this.provinceList[this.form.provinceIndex].province;
        }else {
          this.form.province = this.form.provinceIndex;
        }

        if(regPos.test(this.form.cityIndex)){
          this.form.city = _this.cityList[this.form.cityIndex].city;
        }else {
          this.form.city = this.form.cityIndex;
        }
        const params = {
          ...this.form,
        }
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (!this.checked) {
              Message.error("请勾选阅读并同意用户协议和隐私政策");
              return false;
            }
            this.loading = true;
            // 测试-表单数据采集
            // this.submitFormToHuiju(params);
            // 测试marketup表单数据采集
            // this.submitFormToMarket(params);
            this.postRequestJson('/uacUser/register', JSON.stringify(params)).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  // marketup表单数据采集
                  // this.submitFormToMarket(params);

                  // 荟聚表单数据采集
                  // this.submitFormToHuiju(params);

                  console.log(data);
                  this.$router.replace({path: '/login'});
                } else {
                  Message.error(data.message);
                }
              }
            });
          }
        })
      },
      getRegionInfo(){
        this.getRequest('/uacLocationProvince/getRegionInfo').then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.form.provinceIndex = resp.data.result.Province;
              this.form.cityIndex = resp.data.result.City;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getProvinceList(){
        this.getRequest('/uacLocationProvince/getProvinceList').then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.provinceList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getCityList(event){
        this.getRequest('/uacLocationCity/getList',{'pid':this.provinceList[event].pid}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cityList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getCookie(){
        const cl = Cookies.get('cl');
        if(cl) this.cl = JSON.parse(cl);
      },
      // 提交表单到荟聚
      async submitFormToHuiju(params) {
        let _this = this;
        var utmaVal = document.getElementsByName("cl_context")[0].value;
        let utmaValArr = utmaVal.split('&');
        await $.get("https://host.huiju.cool/formdata/get/762ba725ddd048a68bd61ac734da5bda").done(function (res) {
          let obj = {
            cltoken: res.token,
            name: params.accountId,
            attr3: params.busiScope, // 业务领域
            attr4: params.jobTitle   // 岗位
          }
          if(_this.cl.contentName) {
            obj.attr1 = _this.cl.contentName;
          }
          if(_this.cl.source) obj.attr2 = _this.cl.source;//来源
          utmaValArr.map(item => {
            let itemArr = item.split('=');
            obj[itemArr[0]] = itemArr[1];
          })
          let reqData = Object.assign(params,obj,this.cl);
          $.post("https://host.huiju.cool/form/762ba725ddd048a68bd61ac734da5bda",reqData,function (data, status) {
            console.log('submitFormToHuiju success')
          });
        })
      },
      submitFormToMarket(params) {
        const marketupWidget = new _MARKETUP_CHAT.Widget({
          base: 'https://paraverse.marketup.cn',
        })
        if(marketupWidget) {
          const paramsObj = {
            _username: params.accountId,
            _mobile_phone: params.mobile,
            company_address: params.province + params.city,
            _company: params.company,
            business_type: params.busiScope, // 业务领域
            position: params.jobTitle   // 岗位
          }
          marketupWidget.submitFormData({websiteFormId:4370857068410881,data: paramsObj});
        }
      }
    },
    beforeDestroy() {
      document.onkeydown = undefined;
      // if($("script[src='//cbe.huiju.cool/cbe/collect?tid=5532885912031582559&at=0&h=web']").length){
      //   $("script[src='//cbe.huiju.cool/cbe/collect?tid=5532885912031582559&at=0&h=web']").remove();
      // }
    }
  }
</script>
<style lang="scss">
.authCode {
  position: absolute;
  padding: 0px 20px 0;
  width: 115px;
  height: 40px;
}
.send-btn {
  height: 40px!important;
  line-height: 40px!important;
  .el-button {
    height: 40px!important;
  }
}
.reg-form {
  // margin-right: 40px;
  &-item {
    .el-form-item__content {
      margin-left: 0!important;
    }
  }
  &-label {
    width: 100px;
    display: inline-block;
    vertical-align: middle;
    line-height: 40px;
    text-align: right;
    box-sizing: border-box;
    padding-right: 12px;
  }
  &-label::before{
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}
@media screen and (max-width: 768px) {
  .pxy-main.el-main {
    padding: 20px 16px!important;
  }
  .authCode {
    padding: 0;
  }
}
</style>
